<template>
	<div :class="hide ? 'rightFixedNav hide' : 'rightFixedNav'" :style="{ 'z-index:22;': type != 1, 'bottom:300px': type == 2 }"
		v-if="!demonstrate">
		<div class="box">
			<div v-if="type == 1 && curWebsite.type != 7">
				<div class="right-icon9 right-icon" @click="showOperatDemo"
					v-show="(curWebsite.type == 1 || curWebsite.type == 6 || curWebsite.type == 4 || curWebsite.type == 8 || curWebsite.type == 9) && userdata.token && !userdata.isChannel">
					<!-- operatDemo.vue  暂时只有招商 研究 信贷有操作指引 -->
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">操作指引</span>
				</div>
				<a class="db right-icon1 right-icon"
					v-if="(curWebsite.type == 1 || curWebsite.type == 2 || curWebsite.type == 9) && !userdata.isChannel"
					href="https://share.plvideo.cn/album/index.html?albumId=4841dc66" target="_blank">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">使用说明</span>
				</a>
				<!-- <a class="db right-icon2 right-icon" v-if=" curWebsite.type == 1 || curWebsite.type == 2 || curWebsite.type == 9" href="http://c.ocn.com.cn/special/cydnproduct/indexpx.html"  target="_blank">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">十大功能</span>
				</a> -->
				<a class="db right-icon5 right-icon" href="https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true"
					target="_blank" v-if="curWebsite.type != 8 && !userdata.isChannel">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">问题咨询</span>
				</a>
				<div class="right-icon3 right-icon por" v-show="curWebsite.type == 1 && !userdata.isChannel">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">手机版</span>
					<div class="right-slide">
						<img src="../../assets/xiaochengxuCode.jpg" alt="">
						<p class="right-icon-font">招商大脑手机版</p>
					</div>
				</div>
				<span class="hideRightNavBtn1" v-if="type == 1" title="隐藏" @click="hide = true"><svg t="1691569880529"
						class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
						p-id="7834" width="40" height="40">
						<path
							d="M512 960C265.6 960 64 758.4 64 512S265.6 64 512 64s448 201.6 448 448-201.6 448-448 448z m0-852c-222.2 0-404 181.8-404 404s181.8 404 404 404 404-181.8 404-404-181.8-404-404-404z"
							p-id="7835" fill="#999"></path>
						<path
							d="M652.7 496.4L457.6 301.3c-8.6-8.6-22.5-8.6-31.1 0s-8.6 22.5 0 31.1L606 512 426.4 691.6c-8.6 8.6-8.6 22.5 0 31.1 8.6 8.6 22.5 8.6 31.1 0l195.2-195.2c8.6-8.5 8.6-22.5 0-31.1z"
							p-id="7836" fill="#999"></path>
					</svg></span>
				<div v-if="!userdata.isChannel" class="hideRightNav" v-show="hide" title="展示多宝栏" @click="hide = false">
					<svg t="1691570020057" class="icon" viewBox="0 0 1024 1024" version="1.1"
						xmlns="http://www.w3.org/2000/svg" p-id="8947" width="40" height="40">
						<path
							d="M512 64C265.6 64 64 265.6 64 512s201.6 448 448 448 448-201.6 448-448S758.4 64 512 64z m0 852c-222.2 0-404-181.8-404-404s181.8-404 404-404 404 181.8 404 404-181.8 404-404 404z"
							p-id="8948" fill="#999999"></path>
						<path
							d="M418 512l179.6-179.6c8.6-8.6 8.6-22.5 0-31.1s-22.5-8.6-31.1 0L371.3 496.4c-8.6 8.6-8.6 22.5 0 31.1l195.2 195.2c8.6 8.6 22.5 8.6 31.1 0 8.6-8.6 8.6-22.5 0-31.1L418 512z"
							p-id="8949" fill="#999999"></path>
					</svg></div>
			</div>
			<div v-if="type == 2 && curWebsite.type != 7">
				<div class="right-icon7 right-icon" @click="showApply = true">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">申请试用</span>
				</div>
				<div class="right-icon6 right-icon por">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">联系电话</span>
					<div class="right-slide-phone">
						<em>400 008 0586</em><em>0755-82571568</em>
					</div>
				</div>
				<div class="right-icon4 right-icon por">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">扫码咨询</span>
					<div class="right-slide-wechat">
						<!-- <span class="wechatfont">扫一扫 加微信咨询我们</span> -->
						<div class="wechat_codebox fl">
							<img src="../../assets/images/zixuncode-lss.png">
							<p class="tac">中投顾问 - 刘姗姗</p>
						</div>
						<!-- <div class="wechat_codebox fr">
							<img src="../../assets/images/zixuncode-bl.png">
							<p class="tac">中投顾问 - 白灵</p>
						</div> -->
					</div>
				</div>
				<a class="db right-icon5 right-icon" href="https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true"
					target="_blank">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">在线咨询</span>
				</a>
				<div class="db right-icon8 right-icon" @click="returnTop">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">返回顶部</span>
				</div>
			</div>
			<div v-if="type == 3 && curWebsite.type == 7">
				<div class="right-icon4 right-icon por">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">联系我们</span>
					<div class="right-slide-wechat" style="width: auto;">
						<div class="wechat_codebox fl">
							<img src="../../assets/images/guoshangyun.jpg">
							<!-- <p class="tac">中投顾问 - 刘姗姗</p> -->
						</div>
					</div>
				</div>
				<div class="right-icon6 right-icon por">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">联系电话</span>
					<div class="right-slide-phone">
						<em>137 0189 6866</em><em>133 8110 9559</em>
					</div>
				</div>
				<div class="db right-icon8 right-icon" @click="returnTop">
					<i class="right-icon-logo"></i>
					<span class="right-icon-font">返回顶部</span>
				</div>
			</div>
		</div>
		<!-- 申请试用弹框 登录页面专用 -->
		<div v-if="type == 2">
			<div id="cydnApply" class="cydnApply" v-show="showApply">
				<div class="contentbox">
					<div class="colsecydnApply" @click="showApply = false">X</div>
					<h1 class="bluefont1">申请试用</h1>
					<h3>请完善以下信息，我们顾问会在一个工作日内与您联系</h3>
					<div id="applyform">
						<div class="formLine ">
							<span class="labelLeft"><span class="redfont">*</span>姓名</span>
							<input type="text" v-model="applydata.name" placeholder="请输入您的姓名" name="name" id="name"
								class="inpurRight" />
						</div>
						<div class="formLine formLineHalf">
							<span class="labelLeft"><span class="redfont">*</span>手机号</span>
							<input type="text" v-model="applydata.mobile" placeholder="请输入您的手机号" name="mobile"
								id="mobilenum" class="inpurRight" />
						</div>
						<div class="formLine">
							<span class="labelLeft"><span class="redfont">*</span>政府/园区/机构/企业名称</span>
							<input type="text" v-model="applydata.company" placeholder="请输入您的公司名称" name="company"
								id="enterprisename" class="inpurRight" />
						</div>
						<div class="formLine formLineHalf">
							<span class="labelLeft">您的职务</span>
							<input type="text" v-model="applydata.position" placeholder="请输入您的公司职务" name="position"
								id="job" class="inpurRight" />
						</div>
						<div class="formLine formLineHalf">
							<span class="labelLeft">您的邮箱</span>
							<input type="text" v-model="applydata.email" placeholder="请输入您的邮箱" name="email" id="email"
								class="inpurRight" />
						</div>
						<div class="formLine formLineHalf">
							<span class="labelLeft">备注</span>
							<textarea placeholder="请详细描述您的问题和需求，不超过200字" v-model="applydata.note" maxlength="200"
								name="note" id="remark" class="inpurRight textareainp"></textarea>
						</div>
						<p id="errtext" class="redfont">{{ errtext }}</p>
						<p style="text-align: center;"><span class="fsubmitbtn" @click="submitfun()">立即申请</span></p>
					</div>
				</div>
			</div>
			<div class="formresultbox" id="formresultbox" v-show="hasResult">
				<div class="resultconbox">
					<div class="resultbox-close" @click="hasResult = false">X</div>
					<div class="resultcon">
						<h3 id="fialss">{{ fialss }}</h3>
						<h4>如果您希望尽早试用体验，也可以直接联系我们。</h4>
						<div class="content-box">
							<p>联系电话：<span class="red-font">&nbsp;&nbsp;&nbsp;400 008
									0586;&nbsp;&nbsp;&nbsp;0755-82571568</span></p>
							<p><span class="fl">微信扫码：</span>&nbsp;&nbsp;&nbsp;<span class="weixinimg"><img
										src="http://www.ocn.com.cn/static/images/zixuncode.png" alt="扫码咨询" /></span></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'rightnav',
	data() {
		return {
			demonstrate: this.$api.demonstrate(),
			hide: false,
			operatBtn: true,
			userdata: "",
			iszsdn: this.$api.iszsdn(),
			curWebsite: this.$api.getWebsiteType(),
			showApply: false, hasResult: false, errtext: '', fialss: "您的需求已经提交！",
			applydata: { name: '', mobile: "", company: "", position: "", email: "", note: "" },
		}
	},
	props: {
		msg: String,
		type: { default: 1, require: false },//type =1 通用版 使用说明十大功能 type=2 登录专用 电话 微信 qq type=3 上海数据平台登录页面专用 只保留他们的联系方式和返回顶部
	},
	created() {
		this.userdata = this.getuseriformation();
	},
	methods: {
		showOperatDemo() {
			this.bus.$emit('operatDemo', true, 'total');
		},
		// this.hide=true;
		returnTop() {
			document.getElementById('loginpage').scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		},
		submitfun() {
			var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
			var _this = this;
			if (this.applydata.name == '') {
				this.errtext = '姓名不能为空';
			} else if (this.applydata.mobile == '') {
				this.errtext = '手机号不能为空';
			} else if (this.applydata.company == '') {
				this.errtext = '企业名称不能为空';
			} else if (!reg_tel.test(this.applydata.mobile)) {
				this.errtext = '请正确填写您的手机号码';
			} else {
				this.errtext = '';
				console.log(this.applydata);
				jQuery.ajax({
					type: "post",
					url: 'http://lian.ocn.com.cn/api/cyl/v1/userApply/trial',
					data: this.applydata,
					success: function (result) {
						console.log('applyform', result);
						if (result.success) {
							_this.applydata = { name: '', mobile: "", company: "", position: "", email: "", note: "" };
						} else {
							_this.fialss = '提交失败，请稍后再试！';
						}
						_this.showApply = false;
						_this.hasResult = true;
					}
				})
			}
		},
		// feedbackFun(result){
		// 	console.log('applyform',result);
		// 	if(result.success) {
		// 	document.getElementById("cydnApply").style.display = "none"; 
		// 	document.getElementById("formresultbox").style.display = "block";
		// 		jQuery("#applyform input").val('');
		// 		jQuery("#applyform textarea").val('');
		// 	} else {
		// //			alert("提交失败，请稍候再试！");
		// 	document.getElementById("cydnApply").style.display = "none";
		// 	jQuery('#fialss').html('提交失败，请稍后再试！');
		// 	document.getElementById("formresultbox").style.display = "block"; 
		// 	} 
		// }
	}

}



</script>